"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const winterGroupsService = {
  getWinterGroups: function () {
    return api.get("/WinterGroups", WithToken.headersToken({ params: {} }, configuration.cookieName));
  },

  addUnitWinterGroup: function (options) {
    return api.post(`/WinterGroups`, options, WithToken.headersToken({}, configuration.cookieName));
  },

  deleteUnitWinterGroup: function (options) {
    return api.delete(`/WinterGroups`, WithToken.headersToken({ params: options }, configuration.cookieName));
  },
};

export default winterGroupsService;
